import { z } from "zod";

export const centsSchema = z.string().regex(/^-?\d{1,28}$/u);
export const financeDateSchema = z.iso.date();
export const financeCodeSchema = z.string().regex(/^[A-Za-z0-9._/-]{1,25}$/u);
export const financeSearchSchema = z.array(z.object({ code: financeCodeSchema, name: z.string(), currency: z.string() })).max(20);
export const financeAccountSchema = z.object({
  code: z.string(), name: z.string(), currency: z.string(),
  balance: centsSchema, mainBalance: centsSchema,
  movementCount: z.number().int().nonnegative(), matchingCount: z.number().int().nonnegative(),
  reconciled: z.boolean(),
  paymentTerms: z.string().nullable().optional(),
});
export const financeEntrySchema = z.object({
  id: z.string(), date: financeDateSchema, dueDate: financeDateSchema.nullable(),
  invoiceDate: financeDateSchema.nullable().default(null),
  dueDateSource: z.enum(["document", "account", "unknown"]).optional(),
  runningBalance: centsSchema.nullable().default(null),
  document: z.string(), documentType: z.number().int(), kind: z.string(),
  documentSeries: z.string().optional(), documentSequence: z.number().int().optional(), sourceCurrency: z.string().optional(),
  isInvoice: z.boolean(), isReturn: z.boolean(),
  debit: centsSchema, credit: centsSchema, mainDebit: centsSchema, mainCredit: centsSchema,
  remaining: z.null(),
  links: z.array(z.object({
    otherDocument: z.string(), otherDate: financeDateSchema,
    amount: centsSchema, component: z.enum(["Ara toplam", "Masraf", "Vergi"]),
  })),
});
export const financeReportSchema = z.object({
  id: z.string().uuid(), date: financeDateSchema, company: z.string(),
  startedAt: z.iso.datetime(), observedAt: z.iso.datetime(),
  scope: z.enum(["PILOT_FIVE_ACCOUNTS", "SELECTED_ACCOUNT"]),
  accounts: z.array(financeAccountSchema),
});
export const financeDetailSchema = z.object({
  reportId: z.string().uuid(), account: financeAccountSchema,
  page: z.number().int().positive(), pageSize: z.literal(40),
  total: z.number().int().nonnegative(),
  entries: z.array(financeEntrySchema),
});
export type FinanceAccount = z.infer<typeof financeAccountSchema>;
export type FinanceEntry = z.infer<typeof financeEntrySchema>;
export type FinanceReport = z.infer<typeof financeReportSchema>;
export type FinanceDetail = z.infer<typeof financeDetailSchema>;
